import { ContainerModule } from "inversify";
import * as Api from "@/app/question/components/api";
import * as SerializationApi from '@/app/state-serialization/api';
import MatchingQuestionComponent from "./matching-question-component.vue";
import MatchingQuestionSolutionComponent from "./matching-question-solution-component.vue";
import { MatchingQuestionStateProtobufSerializer } from "./matching-question-state-protobuf-serializer";
import { MatchingQuestionAnswerProtobufSerializer } from "./matching-question-answer-protobuf-serializer";

export const matchingQuestionFactoryModule = new ContainerModule(bind => {
  bind<Api.QuestionComponentPlugin>(Api.QuestionComponentPluginSymbol)
    .toConstantValue(MatchingQuestionComponent)
    .whenTargetNamed("matching");

  bind<Api.QuestionComponentPlugin>(Api.QuestionSolutionPluginSymbol)
    .toConstantValue(MatchingQuestionSolutionComponent)
    .whenTargetNamed("matching");

    bind(SerializationApi.StateSerializationPluginSymbol).to(MatchingQuestionAnswerProtobufSerializer)
    bind(SerializationApi.StateSerializationPluginSymbol).to(MatchingQuestionStateProtobufSerializer)  
});
